var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"btn btn-sm btn-outline-secondary mb-1",attrs:{"to":_vm.view}},[_vm._v("\n        View\n    ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-sm btn-outline-secondary mb-1",attrs:{"to":_vm.edit}},[_vm._v("\n        Edit\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-686bbd41","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableRowActions.vue
// module id = null
// module chunks = 